module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-5435696e70256c81a1ee4f824d756bdd.png";